import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Col, Tabs } from 'antd'
import CampaignHistory from './CampaignHistory'
import { useGlobalQuery } from 'hooks/useGlobalQuery'
import Loading from 'components/Utils/Loading'
import FeatureNotFound from 'components/Misc/FeatureNotFound'
import { useMerchant } from 'hooks/useGlobalContext/useMerchant'

const AppCampaigns = () => {
  const { isLoading } = useGlobalQuery()
  const navigate = useNavigate()
  const location = useLocation()

  const getActiveKey = () => {
    if (
      location.pathname === '/app-campaigns' ||
      location.pathname === '/app-campaigns/new'
    )
      return 'history'
    const path = location.pathname.split('/')
    return path[path.length - 1]
  }

  const handleTabChange = (key: string) => {
    navigate(`/app-campaigns/${key}`)
  }

  useEffect(() => {
    if (location.pathname === '/app-campaigns') {
      navigate('/app-campaigns/history', { replace: true })
    }
  }, [location.pathname, navigate])

  if (isLoading) return <Loading />

  return (
    <Col className='_mt-16' data-testid='app-campaigns'>
      <Tabs
        activeKey={getActiveKey()}
        onChange={handleTabChange}
        destroyInactiveTabPane={true}
      >
        <Tabs.TabPane tab='Campaign History' key='history'>
          <Col>
            <CampaignHistory isPublished={true} />
          </Col>
        </Tabs.TabPane>
        <Tabs.TabPane tab='Scheduled Campaigns' key='scheduled'>
          <Col>
            <CampaignHistory isPublished={false} />
          </Col>
        </Tabs.TabPane>
      </Tabs>
    </Col>
  )
}

const AppCampaignsWrapper = () => {
  const { merchantData } = useMerchant()

  if (merchantData?.app_setting?.enabled) {
    return <AppCampaigns />
  }

  return <FeatureNotFound />
}

export default AppCampaignsWrapper
